import { axiosInstance } from ".."



const addMemberChatList = async (chatID,data) =>{
    return new Promise(async (resolve,reject)=>{
        axiosInstance.put(
          `/internal/chat/addmember/${chatID}`,data
                )
                .then((res) => {
            console.log(res)
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
  }
  
  export default addMemberChatList;